import { PostHog } from 'posthog-js/react/dist/types'
import { createContext } from 'react'

export const PosthogContext = createContext<{ posthog: PostHog | undefined }>({
  posthog: undefined,
})
